import React from 'react';
import { NumericFormat } from 'react-number-format';
import TextField from '@material-ui/core/TextField';

export default function IntTextField(props) {
    return (
        <NumericFormat
            customInput={TextField}
            label={props.label}
            name={props.name}
            id={props.id}
            placeholder={props.placeholder}
            value={props.value}
            disabled={props.disabled}
            onChange={props.handleChange}
            onFocus={props.onFocus}
            className={props.className}
            decimalScale={0}
            isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= props.min && floatValue <= props.max;
            }}
        />
    );
}